<template>
  <div class="report-footer">
    <DivPrintableBackground ref="bg">
      <h3>Looking for more?</h3>
      <ul>
        <template v-if="!isSelectedSchoolPK">

          <li v-if="isCovidYear">Read about changes to the 2019-20 Snapshot related to <LinkExternalUrl url="/resources/2020-equity-changes.html">equity, diversity, and inclusion</LinkExternalUrl> and <LinkExternalUrl url="/resources/2020-covid-19.html">COVID-19</LinkExternalUrl></li>

          <li>Find all school survey results in the <LinkExternalUrl :url="guideURL">School Quality Guide</LinkExternalUrl></li>

          <template v-if="!isSelectedSchoolCharter">
            <li v-if="!hasQRReview">Read about the <LinkExternalUrl url="https://www.schools.nyc.gov/about-us/reports/school-quality/quality-review">Quality Review process</LinkExternalUrl>.</li>
            <li v-else>Read the complete <LinkExternalUrl :url="qualityReviewURL">Quality Review Report (PDF)</LinkExternalUrl></li>
          </template>

          <li v-if="selectedSchoolType==='HS'">Apply to high schools online at <LinkExternalUrl :url="schoolFinderURL">MySchools</LinkExternalUrl></li>
          <li v-else-if="selectedSchoolType==='MS'">Apply online to middle schools at <LinkExternalUrl url="https://www.myschools.nyc/en/schools/middle-school/">MySchools</LinkExternalUrl></li>
          <li v-else-if="['EC','ES'].indexOf(selectedSchoolType)>-1">Apply online to kindergarten at <LinkExternalUrl url="https://www.myschools.nyc/en/schools/kindergarten/">MySchools</LinkExternalUrl></li>
          <li v-else-if="selectedSchoolType==='K-8'">Apply online through the <LinkExternalUrl url="https://www.myschools.nyc/en/schools/kindergarten/">MySchools kindergarten directory</LinkExternalUrl> or the <LinkExternalUrl url="https://www.myschools.nyc/en/schools/middle-school/">MySchools middle school directory</LinkExternalUrl></li>
          <li v-else-if="['YABC','HST'].indexOf(selectedSchoolType)>-1">Find <LinkExternalUrl url="https://www.schools.nyc.gov/enrollment/other-ways-to-graduate/transfer-high-schools">admissions information for transfer high schools</LinkExternalUrl></li>
          <!-- No link for D75 -->

          <li>Multi-year data is on the <LinkExternalUrl :url="dashboardURL">School Performance Dashboard</LinkExternalUrl></li>
        </template>
        <template v-else>
          <li>Find pre-K sites and apply online at <LinkExternalUrl url="https://www.myschools.nyc/en/schools/pre-k/">MySchools</LinkExternalUrl></li>
          <li>Find <LinkExternalUrl url="https://www.schools.nyc.gov/enrollment/enroll-grade-by-grade/pre-k">pre-K admissions information</LinkExternalUrl></li>
          <li>Find out more about the <LinkExternalUrl url="http://NYCSchoolSurvey.org">NYC School Survey</LinkExternalUrl></li>
        </template>
      </ul>

      <template v-if="!isSelectedSchoolPK">
        <div class="asterisk-footer" v-if="!isCovidYear">* The Comparison Group shows how similar students performed at other schools throughout the city. Read about <LinkExternalUrl url="/resources/comp-group.html">how the Comparison Group is calculated</LinkExternalUrl>.</div>
        <div class="asterisk-footer" v-if="isCovidYear">** Attendance rates were calculated from September 2019 to February 2020 due to the impact of COVID-19.</div>
        <div class="asterisk-footer" v-if="['HS','HST'].indexOf(selectedSchoolType)>-1 && isCovidYear">*** Regents exams were not administered in June or August 2020 due to COVID-19.</div>
      </template>
    </DivPrintableBackground>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import Component from 'vue-class-component'

import { NS_CURRENT_REPORT } from './const'

import DivPrintableBackground from '@/components/DivPrintableBackground'
import LinkExternalUrl from '@/components/LinkExternalUrl'

@Component({
  computed: {
    ...mapGetters(NS_CURRENT_REPORT, [
      'selectedSchoolType',
      'isSelectedSchoolCharter',
      'isSelectedSchoolPK',
      'hasQRReview',
      'schoolFinderURL',
      'qualityReviewURL',
      'guideURL',
      'dashboardURL',
      'isCovidYear'
    ])
  },
  components: {
    DivPrintableBackground,
    LinkExternalUrl
  }
})
export default class ReportFooter extends Vue {
  /* Lifecycle */
  updated () {
    this.updateBGSize()
  }

  /* Getters */

  /* Methods - utility */

  updateBGSize () {
    // When content repopulates for print URLs, need to update background size
    //  However, this does not update calculation based on CSS content: rules
    const bg = this.$refs.bg
    if (bg) {
      bg.$_RootSizeMixin_updateInnerSize()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import './css/const.scss';
$bg-color: #b7d1ed;

.div-printable-bg {
  background-color: $bg-color;
  border-color: $bg-color;
  padding: 0px;
  /deep/ .content {
    padding: 24px;
    > * {
      display: block;
    }
  }
}
ul {
  margin-bottom: 0px;
  padding-left: 24px;
}
.report-footer h3 {
  color: black;
  border-bottom: 0px;
  margin: 0px;
}
.asterisk-footer {
  padding-top: 10px;
}

/* Responsive rules */

@media screen and (max-width: $screen-width-2-column-small) {
.div-printable-bg /deep/ .v-outer {
  margin: 0px 10px;
  width: calc(100% - 20px);
  .content {
    padding-left: 0px;
    padding-right: 0px;
  }
}
}
@media screen and (max-width: $screen-width-1-column-large) {
.div-printable-bg /deep/ .v-outer {
  max-width: $max-width-1-col;
  margin: auto;
}
}
@media screen and (max-width: $screen-width-1-column-medium) {
.div-printable-bg /deep/ .v-outer {
  max-width: none;
  margin: 0px;
  .content {
    padding-left: 10px;
    padding-right: 10px;
  }
}
}

</style>



// WEBPACK FOOTER //
// src/components/sqs/2020/ReportFooter.vue